import { IUserAudio } from 'store/types/audio'

import * as Styled from './styled'
import { AudioNoResult } from './no-result'
import { AudioSearchResult } from './search-result'
import { AudioSearchInput } from './audio-search-input'
import { memo, useContext } from 'react'
import { AudioContentContext } from '../../../context'

interface IProps {
  className?: string
  placeholder?: string
  searchValue: string
  onChange: (value: string) => void
  searchResultList: IUserAudio[]
}

const AudioSearchSection: React.FC<IProps> = ({
  placeholder,
  className,
  searchValue,
  onChange,
  searchResultList
}) => {
  const { isAudioSearchLoading } = useContext(AudioContentContext)

  const hasSearchResult = !!searchResultList.length || isAudioSearchLoading

  return (
    <Styled.AudioSearchSectionContainer
      className={className}
      $hasSearchResult={hasSearchResult}
      $hasNotSearchValue={!searchValue}
    >
      <Styled.AudioSearchInputContainer>
        <AudioSearchInput
          placeholder={placeholder}
          value={searchValue}
          onChange={onChange}
        />
      </Styled.AudioSearchInputContainer>

      {hasSearchResult ? (
        <AudioSearchResult audios={searchResultList} />
      ) : searchValue ? (
        <AudioNoResult searchValue={searchValue} />
      ) : null}
    </Styled.AudioSearchSectionContainer>
  )
}

export default memo(AudioSearchSection)
